import { memo, type FC, type PropsWithChildren } from 'react';

import { useScrollNavigationContext } from '../../../../hooks/useScrollNavigation/index.ts';
import { Wrapper } from './styled.ts';

export const VerticalNavigationGroupWrapper: FC<PropsWithChildren> = memo(function VerticalNavigationGroupWrapper({ children }) {
  const { offset } = useScrollNavigationContext();

  return <Wrapper $offset={offset}>{children}</Wrapper>;
});
